export const componentsIconLocalizationMap = {
    FFXCCalendar: {
        rtlIconName: 'FFXCCalendarMirrored'
    },
    FFXCClipboardList: {
        rtlIconName: 'FFXCClipboardListMirrored'
    },
    FFXCBulletedList: {
        rtlIconName: 'FFXCBulletedListMirrored'
    },
    FFXCNumberedList: {
        rtlIconName: 'FFXCNumberedListMirrored'
    },
    FFXCChecklist: {
        rtlIconName: 'FFXCChecklistMirrored'
    },
    FFXCChevronRight: {
        rtlIconName: 'FFXCChevronLeft'
    },
    FFXCIncreaseIndent: {
        rtlIconName: 'FFXCIncreaseIndentMirrored'
    },
    FFXCDecreaseIndent: {
        rtlIconName: 'FFXCDecreaseIndentMirrored'
    },
    FFXCSeeMore: {
        rtlIconName: 'FFXCSeeMoreMirrored'
    },
    FFXQuickSync: {
        rtlIconName: 'FFXQuickSyncMirrored'
    },
    FFXCBody: {
        rtlIconName: 'FFXCBodyMirrored'
    },
    FFXCBold: {
        localizedIconNames: {
            'bg-bg': 'FFXCBoldBulgarian',
            'ca-es': 'FFXCBoldN',
            'da-dk': 'FFXCBoldF',
            'de-de': 'FFXCBoldF',
            'es-es': 'FFXCBoldN',
            'es-mx': 'FFXCBoldN',
            'et-ee': 'FFXCBoldP',
            'eu-es': 'FFXCBoldN',
            'fr-ca': 'FFXCBoldG',
            'fr-fr': 'FFXCBoldG',
            'gl-es': 'FFXCBoldN',
            'hu-hu': 'FFXCBoldF',
            'it-it': 'FFXCBoldG',
            'kk-kz': 'FFXCBoldKazakh',
            'ko-kr': 'FFXCBoldKorean',
            'lt-lt': 'FFXCBoldP',
            'lv-lv': 'FFXCBoldT',
            'ms-my': 'FFXCBoldT',
            'nb-no': 'FFXCBoldF',
            'nn-no': 'FFXCBoldF',
            'pt-br': 'FFXCBoldN',
            'pt-pt': 'FFXCBoldN',
            'ru-ru': 'FFXCBoldRussian',
            'sl-si': 'FFXCBoldK',
            'sr-cyrl-rs': 'FFXCBoldSerbian',
            'sr-latn-rs': 'FFXCBoldP',
            'sv-se': 'FFXCBoldF',
            'tr-tr': 'FFXCBoldK',
            'uk-ua': 'FFXCBoldRussian'
        }
    },
    FFXCItalic: {
        localizedIconNames: {
            'bg-bg': 'FFXCItalicK',
            'ca-es': 'FFXCItalicK',
            'da-dk': 'FFXCItalicK',
            'de-de': 'FFXCItalicK',
            'es-es': 'FFXCItalicK',
            'es-mx': 'FFXCItalicK',
            'et-ee': 'FFXCItalicK',
            'eu-es': 'FFXCItalicK',
            'gl-es': 'FFXCItalicK',
            'hu-hu': 'FFXCItalicD',
            'it-it': 'FFXCItalicC',
            'kk-kz': 'FFXCItalicKazakh',
            'ko-kr': 'FFXCItalicKorean',
            'lt-lt': 'FFXCItalicK',
            'lv-lv': 'FFXCItalicS',
            'nb-no': 'FFXCItalicK',
            'nn-no': 'FFXCItalicK',
            'ru-ru': 'FFXCItalicK',
            'sl-si': 'FFXCItalicL',
            'sr-cyrl-rs': 'FFXCItalicK',
            'sr-latn-rs': 'FFXCItalicK',
            'sv-se': 'FFXCItalicK',
            'tr-tr': 'FFXCItalicT',
            'uk-ua': 'FFXCItalicK'
        }
    },
    FFXCFontColor: {
        localizedIconNames: {
            'ko-kr': 'FFXCFontColorKorean'
        }
    },
    FFXCStrikethrough: {
        localizedIconNames: {
            'ko-kr': 'FFXCStrikethroughKorean'
        }
    },
    FFXCUnderline: {
        localizedIconNames: {
            'bg-bg': 'FFXCUnderlineSerbian',
            'ca-es': 'FFXCUnderlineS',
            'es-es': 'FFXCUnderlineS',
            'es-mx': 'FFXCUnderlineS',
            'et-ee': 'FFXCUnderlineA',
            'eu-es': 'FFXCUnderlineS',
            'fr-ca': 'FFXCUnderlineS',
            'fr-fr': 'FFXCUnderlineS',
            'gl-es': 'FFXCUnderlineS',
            'hu-hu': 'FFXCUnderlineA',
            'it-it': 'FFXCUnderlineS',
            'kk-kz': 'FFXCUnderlineA',
            'ko-kr': 'FFXCUnderlineKorean',
            'lt-lt': 'FFXCUnderlineP',
            'lv-lv': 'FFXCUnderlineP',
            'pt-br': 'FFXCUnderlineS',
            'pt-pt': 'FFXCUnderlineS',
            'ru-ru': 'FFXCUnderlineRussian',
            'sl-si': 'FFXCUnderlineP',
            'sr-cyrl-rs': 'FFXCUnderlineSerbian',
            'sr-latn-rs': 'FFXCUnderlineP',
            'tr-tr': 'FFXCUnderlineA',
            'uk-ua': 'FFXCUnderlineSerbian'
        }
    }
};
